import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, accessToken) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    headers: { accesstoken: accessToken },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function deleteWatchlist(list_name, accessToken) {
  const data = await fetchAPI(
    `mutation { deleteWatchlist(name: "${list_name}") { status }}`, accessToken
  )
  return data
}

